module.exports = __webpack_public_path__ + "static/media/layer.a27bdd05.svg";